import { gql } from '@apollo/client';

import { DocumentFragment } from 'approot/shared/graphql/document/document.graphql';

export const lessonWorksheetFragment = gql`
  fragment LessonWorksheetFragment on Lesson {
    id
    bookmarked
    bookmarkMetaData {
      workSheetPages
      vocabularyEnPages
      vocabularyEsPages
      stimulusResourceIds
      activitiesBookmarks {
        version
        sectionIds
      }
    }
    worksheet {
      id
      document {
        ...documentFragment
      }
    }
    printableVocabularyEnSheet {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    printableVocabularyEsSheet {
      id
      documentType
      document {
        ...documentFragment
      }
    }
  }
  ${DocumentFragment}
`;

export const DELETE_LESSON_WORKSHEET = gql`
  mutation DeleteLessonWorksheet($input: DeleteLessonWorksheetInput!) {
    deleteLessonWorksheet(input: $input) {
      id
      ...LessonWorksheetFragment
    }
  }
  ${lessonWorksheetFragment}
`;

export const ADD_LESSON_WORKSHEET = gql`
  mutation AddLessonWorksheet($input: AddLessonWorksheetInput!) {
    addLessonWorksheet(input: $input) {
      id
      ...LessonWorksheetFragment
    }
  }
  ${lessonWorksheetFragment}
`;
